import React from "react";

function HorseForm({ additionalAttributes, setAdditionalAttributes }) {
  const handleChange = (e) => {
    setAdditionalAttributes({
      ...additionalAttributes,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="horseForm">
      {/* Cins seçimi */}
      <div>
        <h3>Atın Cinsi <span>*</span></h3>
        <select name="horseBreed" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Ərəb atı">Ərəb atı</option>
          <option value="İngilis atı">İngilis atı</option>
          <option value="Qarabağ atı">Qarabağ atı</option>
          <option value="Akhal-Teke">Akhal-Teke</option>
          <option value="Friz atı">Friz atı</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

      {/* Yaş */}
      <div>
        <h3>Yaş (Ay və ya İl) <span>*</span></h3>
        <input type="number" name="age" min="0" max="40" required placeholder="Yaşı daxil edin" onChange={handleChange} />
      </div>

      {/* Cinsiyyət */}
      <div>
        <h3>Cinsiyyəti <span>*</span></h3>
        <select name="gender" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Ayğır">Ayğır</option>
          <option value="Madyan">Madyan</option>
          <option value="Qısır">Qısır</option>
          <option value="Kısrak">Kısrak</option>
        </select>
      </div>

      {/* Boy */}
      <div>
        <h3>Boy (sm) <span>*</span></h3>
        <input type="number" name="height" min="50" max="220" required placeholder="Atın boyunu daxil edin" onChange={handleChange} />
      </div>

      {/* Çəki */}
      <div>
        <h3>Çəki (kg) <span>*</span></h3>
        <input type="number" name="weight" min="50" max="1200" required placeholder="Çəkini daxil edin" onChange={handleChange} />
      </div>

      {/* Rəng */}
      <div>
        <h3>Rəng <span>*</span></h3>
        <input type="text" name="color" required placeholder="Rəngi daxil edin" onChange={handleChange} />
      </div>

      {/* Sağlamlıq vəziyyəti */}
      <div>
        <h3>Sağlamlıq vəziyyəti <span>*</span></h3>
        <select name="healthStatus" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Sağlam">Sağlam</option>
          <option value="Müalicə olunmuş">Müalicə olunmuş</option>
          <option value="Xəstə">Xəstə</option>
          <option value="Peyvənd olunmuş">Peyvənd olunmuş</option>
        </select>
      </div>


      {/* İdman və ya İş üçün */}
      <div>
        <h3>At hansı məqsəd üçün istifadə olunur? <span>*</span></h3>
        <select name="usage" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="İdman">İdman</option>
          <option value="Hobbiyə uyğun">Hobbiyə uyğun</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

    </div>
  );
}

export default HorseForm;
